import $ from 'jquery';

const getFinalPrice = () => {
  const basePrice = parseFloat($('.product-view .price').data('price'));
  let price = basePrice;

  $('#product_addtocart_form .custom-radio [type=radio]:checked').each(function() {
    const p = parseFloat($(this).data('price'));
    if (p) price += p;
  });

  return price;
};

$(document).ready(function () {
  if ($('.product-view').length) {
    $('#product_addtocart_form .custom-control-input').on('click change', function () {
      const price = getFinalPrice();
      const base_price = parseFloat($('.product-view .price').data('price'));

      $('.product-view .price').html($.formatPrice(price));

      $('#product_addtocart_form .custom-radio [type=radio]').each(function () {
        const p = parseFloat($(this).data('price')) + base_price - price;
        const wrap = $(this).parent().find('.option-price');

        wrap.html($.formatPrice(p));

        if (p) {
          wrap.show();
        } else {
          wrap.hide();
        }
      });
    });

    $('#product_addtocart_form').on('submit', function (e) {
      const not_filled = [];

      $('.required-option.radio-option').each(function () {
        if ($(this).find(':checked').length < 1)
          not_filled.push($(this));
      });

      if (not_filled.length > 0) {
        e.preventDefault();

        for (let t of not_filled) {
          t.find('.required-message').show();
        }
      }

      const item_wrap = $('.custom-control-input:checked').parent();

      const product_data = {
        name: $('.product-view').data('name'),
        id: $('.product-view').data('sku'),
        category: $('.product-view').data('category'),
        price: $('[data-price]').data('price'),
        variant: $.trim(item_wrap.find('.custom-control-label').data('uni-value')),
        quantity: 1
      }

      if (!product_data.variant) {
        product_data.variant = $.trim(item_wrap.find('.custom-control-label').text());
      }
	  
    });
  }
});
